/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
==========================================================================================*/
import _ from 'lodash'
import initialStoreModules from './store.js'
const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val
  },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    if (payload.compte != null) {
      if (payload.customer_No != null) {

        state.AppActiveUser.customer_No = payload.customer_No
      }
      if (payload.compte.username != null)
        state.AppActiveUser.username = payload.compte.username;
      if (payload.nom != null) {
        if (payload.prenom != null)
          state.AppActiveUser.displayName = payload.nom + "-" + payload.prenom;
        else
          state.AppActiveUser.displayName = payload.nom
      }
      if (payload.status != null)
        state.AppActiveUser.status = payload.status;
      if (payload.compte.role != null)
        state.AppActiveUser.userRole = payload.compte.role.designation;
      if (payload.id != null)
        state.AppActiveUser.id = payload.id;
      if (payload.nom != null)
        state.AppActiveUser.nom = payload.nom;
      if (payload.prenom != null)
        state.AppActiveUser.prenom = payload.prenom;
      if (payload.email != null)
        state.AppActiveUser.email = payload.email;
      if (payload.dob != null)
        state.AppActiveUser.dob = payload.dob;
      if (payload.genre != null)
        state.AppActiveUser.genre = payload.genre;
      if (payload.compte.role != null)
        state.AppActiveUser.role = payload.compte.role.designation;
      if (payload.telephone != null)
        state.AppActiveUser.mobile = payload.telephone;
      if (payload.webSite != null)
        state.AppActiveUser.website = payload.webSite;
      if (payload.add_line_1 != null && state.AppActiveUser.location != null)
        state.AppActiveUser.location.add_line_1 = payload.add_line_1;
      if (payload.add_line_2 != null && state.AppActiveUser.location != null)
        state.AppActiveUser.location.add_line_2 = payload.add_line_2;
      if (payload.post_code != null && state.AppActiveUser.location != null)
        state.AppActiveUser.location.post_code = payload.post_code;
      if (payload.ville != null && state.AppActiveUser.location != null)
        state.AppActiveUser.location.ville = payload.ville;
      if (state.AppActiveUser.social_links != null) {
        if (payload.twitter != null)
          state.AppActiveUser.social_links.twitter = payload.twitter;
        if (payload.facebook != null)
          state.AppActiveUser.social_links.facebook = payload.facebook;
        if (payload.instagram != null)
          state.AppActiveUser.social_links.instagram = payload.instagram;
      }
      if (state.AppActiveUser.societe != null && payload.societe != null) {
        if (payload.societe.ville != null)
          state.AppActiveUser.societe.ville = payload.societe.ville;
        if (payload.societe.gouvernorat != null)
          state.AppActiveUser.societe.gouvernorat = payload.societe.gouvernorat;
        if (payload.societe.pays != null)
          state.AppActiveUser.societe.pays = payload.societe.pays;
        if (payload.societe.libelle != null)
          state.AppActiveUser.societe.nom = payload.societe.libelle;
        if (payload.societe.adresse != null)
          state.AppActiveUser.societe.adresse = payload.societe.adresse;
        if (payload.societe.telephone != null)
          state.AppActiveUser.societe.telephone = payload.societe.telephone;
        if (payload.societe.fax != null)
          state.AppActiveUser.societe.fax = payload.societe.fax;
        if (payload.societe.webSite != null)
          state.AppActiveUser.societe.siteWeb = payload.societe.webSite;
        if (payload.societe.longtitude != null)
          state.AppActiveUser.societe.longtitude = payload.societe.longtitude;
      }
      if (payload.nbPoint != null)
        state.AppActiveUser.nbPoint = payload.nbPoint;
      localStorage.setItem("userInfo", JSON.stringify(state.AppActiveUser))
    }
    else {
      state.AppActiveUser = JSON.parse(
        JSON.stringify(Defaults))
    }
  },

  UPDATE_USER_INFO_Account(state, payload) {
    if (payload.nom != null)
      state.AppActiveUser.nom = payload.nom;
    if (payload.prenom != null)
      state.AppActiveUser.prenom = payload.prenom;
    if (payload.email != null)
      state.AppActiveUser.email = payload.email;
  },
  UPDATE_USER_INFO_Information(state, payload) {
    if (payload.dob != null)
      state.AppActiveUser.dob = payload.dob;
    if (payload.genre != null)
      state.AppActiveUser.genre = payload.genre;
    if (payload.telephone != null)
      state.AppActiveUser.mobile = payload.telephone;
    if (payload.webSite != null)
      state.AppActiveUser.website = payload.webSite;
    if (payload.add_line_1 != null)
      state.AppActiveUser.location.add_line_1 = payload.add_line_1;
    if (payload.add_line_2 != null)
      state.AppActiveUser.location.add_line_2 = payload.add_line_2;
    if (payload.post_code != null)
      state.AppActiveUser.location.post_code = payload.post_code;
    if (payload.ville != null)
      state.AppActiveUser.location.ville = payload.ville;
  },
  UPDATE_USER_INFO_Social(state, payload) {
    if (payload.twitter != null)
      state.AppActiveUser.social_links.twitter = payload.twitter;
    if (payload.facebook != null)
      state.AppActiveUser.social_links.facebook = payload.facebook;
    if (payload.instagram != null)
      state.AppActiveUser.social_links.instagram = payload.instagram;
  },
  UPDATE_USER_INFO_USERNAME(state, payload) {
    if (payload.username != null)
      state.AppActiveUser.username = payload.username;

  }
  ,
  UPDATE_USER_IMAGE(state, payload) {
    if (payload != null)
      state.AppActiveUser.image = payload;
  },
  UPDATE_USER_GLOBAL_IMAGE(state, payload) {
    if (payload != null)
      state.AppActiveUser.image = payload;
  },
  INIT_USER_INFO(state, payload) {
    state.AppActiveUser = payload;
    state.AppActiveUser = JSON.parse(
      JSON.stringify(Defaults));
  },
  resetState(state, payload) {
    console.log(payload)
    _.forOwn(initialStoreModules, (value, key) => {
      state[key] = _.cloneDeep(value.state);
    });
  },

  InitStore(state) {
    state.AppActiveUser = {
      nbPoint  : 0 ,
      customer_No : '',
      username: "cogepha",
      uid: 0,          // From Auth
      displayName: "", // From Auth
      photo: require("@/assets/images/portrait/small/avatar-s-3.jpg"), // From Auth
      status: "online",
      userRole: "",
      "id": '0',
      "nom": "",
      "email": "",
      "prenom": "",
      "dob": "",
      "genre": "",
      "role": "",
      "is_verified": true,
      "department": "",
      "mobile": "",
      "website": "",
      "languages_known": ["English", "Arabic"],
      "contact_options": ["email", "message", "phone"],
      "location": {
        "add_line_1": "",
        "add_line_2": "",
        "post_code": "",
        "ville": {
          id: 0,
          designation: "",
          "gouvernorat": {
            id: 0,
            designation: "",
            "pays": {
              id: 0,
              designation: "",
            }
          }
        }
      },
      "social_links": {
        "twitter": "",
        "facebook": "",
        "instagram": "",
      },
      "societe": {
        "nom": "",
        "pays": {
          id: 0,
          designation: ""
        },
        "gouvernorat": {
          id: 0,
          designation: "",
          idPays: 0
        },
        "ville": {
          id: 0,
          designation: "",
          idGouvernorat: 0
        },
        "adresse": "",
        "telephone": "",
        "fax": "",
        "siteWeb": "",
      }

    }

  },
  IS_SOCKET_CONNECTED(state, payload) {
    state.connected = payload
  },
  UPDATE_LIVREUR_ID(state, payload) {
    state.AppActiveLivreur.id = payload.id
  }

}


const Defaults = {
  nbPoint  : 0 ,
  username: "cogepha",
  customer_No: '',
  uid: 0,          // From Auth
  displayName: "", // From Auth
  image: require('../../public/profile_default.png'),
  status: "online",
  userRole: "Public",
  "id": '0',
  "nom": "",
  "email": "",
  "prenom": "",
  "dob": "",
  "genre": "",
  "role": "",
  "is_verified": true,
  "department": "",
  "mobile": "",
  "website": "",
  "languages_known": ["English", "Arabic"],
  "contact_options": ["email", "message", "phone"],
  "location": {
    "add_line_1": "",
    "add_line_2": "",
    "post_code": "",
    "ville": {
      id: 0,
      designation: "",
      "gouvernorat": {
        id: 0,
        designation: "",
        "pays": {
          id: 0,
          designation: "",
        }
      }
    }
  },
  "social_links": {
    "twitter": "",
    "facebook": "",
    "instagram": "",
  },
  "societe": {
    "nom": "",
    "pays": {
      id: 0,
      designation: ""
    },
    "gouvernorat": {
      id: 0,
      designation: "",
      idPays: 0
    },
    "ville": {
      id: 0,
      designation: "",
      idGouvernorat: 0
    },
    "adresse": "",
    "telephone": "",
    "fax": "",
    "siteWeb": "",
  }

}


export default mutations
